
import moment from 'moment';
import { BaseQuery2 } from '@/utils';
/**
 * @startDate
 * @endDate
 * @destinationSite
*/
// 卸车时间、主单号、结算重量
export const ModalsQuery = params => {
  return [
    {
      // 一派留仓 明细
      simpleGranularity: 'all',
      dataSource: 'opt_stock_site_waybill_result',
      dimensions: ['waybillNo'],
      startDate: params.startDate,
      endDate: params.endDate,
      aggregators: BaseQuery2(),
      // queryType: 'scan',
      andFilters: [
        { key: 'type', value: '一派留仓' },
        { key: 'scanType', value: '分拨卸车' },
        { key: 'destinationSite', value: params.destinationSite },
        { key: 'receiveSite', value: params.receiveSite },
        { key: 'scanSite', value: params.centerFilter }
      ],
      boundFilters: [
        {
          "dimension": "piece",
          "lowerValue": 1,
          "lowerEq": false,
        }
      ]
    },
    {
      // 二派留仓 明细
      simpleGranularity: 'all',
      dataSource: 'opt_stock_site_waybill_result',
      dimensions: ['waybillNo'],
      startDate: params.startDate,
      endDate: params.endDate,
      aggregators: BaseQuery2(),
      // queryType: 'scan',
      andFilters: [
        { key: 'type', value: '二派留仓' },
        { key: 'scanType', value: '分拨卸车' },
        { key: 'destinationSite', value: params.destinationSite },
        { key: 'receiveSite', value: params.receiveSite },
        { key: 'scanSite', value: params.centerFilter }
      ],
      boundFilters: [
        {
          "dimension": "piece",
          "lowerValue": 1,
          "lowerEq": false,
        }
      ]
    }
  ]
}
